<template>
  <div class="container">
    <nav class="add-navigation d-sm-flex align-sm-center justify-content-sm-between">
      <div @click="$router.push({name: 'system-admin-payment-term-list'})" class="back-link mr-3">
        <svg class="icon" width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p>Back to Payment Terms</p>
      </div>
      <div class="buttons-wrapper my-3 my-sm-0">
        <div
          @click="$router.push({name: 'system-admin-payment-term-list'})"
          class="secondary-button mr-md-3 mr-2"
        >
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button">
          <primary-button class=" px-3 px-sm-4" @click.native="editPayment">Edit Payment Term</primary-button>
        </div>
      </div>
    </nav>
    <div class="add-container">
      <span class="container-title d-flex">Edit Payment Term Information</span>
      <div class="row p-3 mt-1">
        <div class="col-sm-6 col-12">
          <primary-input
            type="text"
            name="name"
            class="field"
            v-model="payment.name"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('name')}"
            placeholder="Enter name"
          />
          <div class="help is-danger" v-if="errors.has('name')">{{ errors.first('name') }}</div>
          <primary-select
            type="text"
            name="payment cycle"
            class="type"
            v-validate="'required'"
            v-model="payment.type"
            :class="{'input': true, 'is-danger': errors.has('payment cycle')}"
            placeholder="Role"
          >
            <option v-for="(i, k) in type" :value="i" :key="k">{{i}}</option>
          </primary-select>
          <div
            v-if="errors.has('payment cycle')"
            class="help is-danger"
          >{{ errors.first('payment cycle') }}</div>
        </div>
        <div class="col-sm-6 col-12">
          <primary-select
            v-if="payment.type == this.type[1]"
            type="text"
            name="days"
            class="valForType"
            v-validate="{required: payment.type == this.type[1]}"
            v-model="payment.days"
            :class="{'input': true, 'is-danger': errors.has('days')}"
            placeholder="Role"
          >
            <option v-for="(i, k) in period" :value="i" :key="k">{{ i + nth(i) }}</option>
          </primary-select>
          <primary-select
            v-if="payment.type == this.type[2]"
            type="text"
            name="days"
            class="valForType"
            v-validate="{required: payment.type == this.type[2]}"
            v-model="payment.days"
            :class="{'input': true, 'is-danger': errors.has('role')}"
            placeholder="Role"
            :options="weeks"
          >
            <!-- <option v-for="(i, k) in weeks" :value="i" :key="k">{{i}}</option> -->
          </primary-select>
          <primary-select
            v-if="payment.type == this.type[0]"
            type="text"
            name="days"
            class="valForType"
            v-validate="{required: payment.type == this.type[0]}"
            v-model="payment.days"
            :class="{'input': true, 'is-danger': errors.has('role')}"
            placeholder="Role"
          >
            <option v-for="(i, k) in period" :value="i" :key="k">{{i}}</option>
          </primary-select>
          <primary-input
            v-if="payment.type == this.type[3]"
            type="text"
            name="days"
            class="field valForType"
            v-model="payment.days"
            v-validate="{required: payment.type == this.type[3]}"
            :class="{'input': true, 'is-danger': errors.has('days')}"
            placeholder="Enter name"
          />
          <div v-if="errors.has('days')" class="help is-danger">{{ errors.first('days') }}</div>
          <primary-select
            type="text"
            name="grace period"
            v-validate="'required'"
            v-model="payment.grace_days"
            :class="{'input': true, 'is-danger': errors.has('grace period')}"
            placeholder="grace period"
          >
            <option v-for="(i, k) in period" :value="i" :key="k">{{i}}</option>
          </primary-select>
          <div
            v-if="errors.has('grace period')"
            class="help is-danger"
          >{{ errors.first('grace period') }}</div>
          <primary-select
            type="text"
            name="notify days"
            class="field"
            v-validate="'required'"
            v-model="payment.notify_days"
            :class="{'input': true, 'is-danger': errors.has('notify days')}"
            placeholder="Role"
          >
            <option v-for="(i, k) in period" :value="i" :key="k">{{i}}</option>
          </primary-select>
          <div
            v-if="errors.has('notify days')"
            class="help is-danger"
          >{{ errors.first('notify days') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    AppDropzone: () => import("@/components/Dropzone"),
  },
  data: () => ({
    type: [
      "Every",
      "Day of Month",
      "Day of Week",
      "Some day of month",
      "Twice a month",
    ],
    period: [],
    weeks: [
      { name: "Monday", value: 1 },
      { name: "Tuesday", value: 2 },
      { name: "Wednesday", value: 3 },
      { name: "Thursday", value: 4 },
      { name: "Friday", value: 5 },
      { name: "Saturday", value: 6 },
      { name: "Sunday", value: 7 },
    ],
    valForType: null,
    payment: {
      name: null,
      grace_days: null,
      days: [],
      notify_days: null,
      type: null,
    },
  }),
  created() {
    for (var i = 0; i <= 30; i++) {
      this.period.push(i);
    }
    this.getPayment();
  },
  methods: {
    nth(n) {
      return ["st", "nd", "rd"][((((n + 90) % 100) - 10) % 10) - 1] || "th";
    },
    getPayment() {
      this.$store
        .dispatch("GetPaymentTermById", { id: this.$route.params.id })
        .then((res) => {
          this.payment.name = res.name;
          this.payment.grace_days = res.grace_days;
          this.payment.days = res.days;
          this.payment.notify_days = res.notify_days;
          this.payment.type = res.type;
        });
    },
    editPayment: async function () {
      const valid = await this.$validator.validate();
      if (!valid) {
        return;
      }

      try {
        await this.$store.dispatch("EditPaymentTerm", {
          payment: this.payment,
          id: this.$route.params.id,
        });

        this.$snotify.success("Payment term have been added.", {
          timeout: 6000,
        });

        this.$router.push({ name: "system-admin-payment-term" });
      } catch (err) {
        this.$error(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  font-family: "Helvetica Neue";
  padding: 0 20px;
  .add-navigation {
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        white-space: nowrap;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
      }
    }
  }
  .add-container {
    flex-direction: column;
    align-items: center;
    background-color: #ffffff;
    padding-top: 15px;
    .container-title {
      height: 30px;
      color: #000000;
      font-size: 16px;
      font-weight: 500;
      line-height: 30px;
      padding: 0 0 15px 15px;
    }
    .col-wrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      padding-left: 15px;
      .col {
        width: 100%;
        padding: 0;
        margin-right: 15px;
        .input {
          margin-bottom: 20px;
        }
        .field {
          p.pimary-input-title {
            color: #000000;
            font-family: "Helvetica Neue";
            font-size: 12px;
            font-weight: 900;
          }
        }
        .pimary-input-title {
          color: #000000;
          font-family: "Helvetica Neue";
          font-size: 12px;
          font-weight: 900;
          letter-spacing: 0.21px;
          line-height: 15px;
          margin-bottom: 5px;
          text-transform: uppercase;
        }
      }
    }

    .row .input {
      margin-bottom: 20px;
    }
  }
}
</style>

